<div class="container-fluid d-flex flex-column min-vh-100">
  <!-- Main Content -->
  <div class="container flex-grow-1">
    <router-outlet></router-outlet>
  </div>
  <footer class="mt-3">
    <div class="container">
      <div class="row">
        <div class="col-12 mt-4 mb-4">
          <app-footer-link></app-footer-link>
        </div>
      </div>
    </div>
  </footer>
</div>
